import Vue from '@vue/compat';
import messagePageOptions from './message-page.js';

function mountPage(selector, options) {
  if (!document.querySelector(selector)) return null;
  return new Vue({ el: selector, ...options });
}

window.qkMessagePage = mountPage('.message-page', messagePageOptions);

export { messagePageOptions };
